export default {
  meta: {
    title: '资源审核-去审核'
  }
};
